import {
  Box,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  useDisclosure,
  Badge,
  HStack,
  Text,
} from "@chakra-ui/react";
import { ShoppingCart } from "lucide-react";
import { useAppSelector } from "../../store/hooks/hooks";
import Cart from "./Cart";
import { useNavigate } from "react-router-dom";
import { useCustomTheme } from "../../contexts/CustomThemeContext";

const StickyCartButton = () => {
  const cart = useAppSelector((state) => state.cart);
  const totalItemCount = cart.items.reduce(
    (sum, item) => sum + (item.quantity || 0),
    0,
  );
  const { isOpen, onOpen, onClose } = useDisclosure();
  const navigate = useNavigate();
  const { theme } = useCustomTheme();
  const cardsBorderRadii = "8px";
  if (totalItemCount < 1) return null;

  return (
    <>
      <Box
        position="fixed"
        bottom={{ base: "80px", md: "20px" }}
        right="20px"
        zIndex={999}
      >
        <Button
          size="lg"
          boxShadow={theme.shadowLg}
          borderRadius={theme.radii.sm}
          color={theme.textOnPrimary}
          bg={theme.name === "dark" ? "#0F172A" : "#111827"}
          border={`1px solid ${
            theme.name === "dark"
              ? "rgba(255,255,255,0.10)"
              : "rgba(15,23,42,0.10)"
          }`}
          _hover={{
            bg: theme.name === "dark" ? "#111827" : "#1E293B",
            transform: "translateY(-1px)",
          }}
          _active={{
            bg: theme.name === "dark" ? "#1E293B" : "#0F172A",
            transform: "translateY(0)",
          }}
          transition="all 0.2s ease"
          leftIcon={<ShoppingCart size={18} />}
          onClick={onOpen}
          px={5}
        >
          <HStack spacing={2}>
            <Text>View items</Text>
            <Badge
              borderRadius={cardsBorderRadii}
              px={2}
              py={0.5}
              bg={
                theme.name === "dark"
                  ? "rgba(255,255,255,0.12)"
                  : "rgba(255,255,255,0.18)"
              }
              color="#FFFFFF"
              fontWeight="700"
            >
              {totalItemCount}
            </Badge>
          </HStack>
        </Button>
      </Box>

      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size="2xl"
        isCentered
        motionPreset="slideInBottom"
      >
        <ModalOverlay bg={theme.overlay} />

        <ModalContent
          containerProps={{
            p: { base: 3, md: 6 },
          }}
          borderRadius={cardsBorderRadii}
          bg={theme.surface}
          border="1px solid"
          borderColor={theme.border}
          boxShadow={theme.shadowLg}
        >
          <ModalHeader color={theme.text}>Your Cart</ModalHeader>
          <ModalCloseButton />

          <ModalBody pb={4}>
            <Cart
              onCheckout={() => {
                onClose();
                navigate("/checkout");
              }}
            />
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default StickyCartButton;
